// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"ReactLoader_loaderWrapper__at+4d","loader":"ReactLoader_loader__LbcXq","rotate":"ReactLoader_rotate__Y3NpG"};